import type { ReportListStatus } from '@/models/report';
import type { ApiStudyWithReports } from '@/models/study';
import type { StudyReportVersion, TimelineStudy } from '../types/studyTimeline';

const MODALITY_NAMES: Record<string, string> = {
  TTE: 'Transthoracic Echo',
  STRESS_ECHO: 'Stress Echo',
};

function modalityToCode(modality: string | null | undefined): string {
  return modality?.toLowerCase() ?? '';
}

function modalityToName(modality: string | null | undefined): string {
  if (!modality) return '';
  return MODALITY_NAMES[modality] ?? modality;
}

function mapReports(
  reports: ApiStudyWithReports['reports']
): StudyReportVersion[] {
  const sorted = [...reports].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  return sorted.map((r, index) => ({
    uuid: r.uuid,
    status: (r.isAddendum ? 'ADDENDUM' : r.status) as ReportListStatus,
    timestamp: r.createdAt,
    authorFirstName: r.signerFirstName ?? '',
    authorLastName: r.signerLastName ?? '',
    isCurrent: index === 0,
  }));
}

export function mapApiStudyToTimeline(
  apiStudy: ApiStudyWithReports,
  isLatest: boolean
): TimelineStudy {
  return {
    uuid: apiStudy.uuid,
    studyTypeName: modalityToName(apiStudy.modality),
    studyTypeCode: modalityToCode(apiStudy.modality),
    studyDateTime: apiStudy.studyDate,
    updatedAt: apiStudy.updatedAt,
    accessionNumber: apiStudy.accessionNumber,
    orderNumber: apiStudy.encounterNumber,
    referringPhysicianName: [
      apiStudy.referringPhysicianFirstName,
      apiStudy.referringPhysicianLastName,
    ]
      .filter(Boolean)
      .join(' '),
    referringPhysicianDepartment: '',
    readingPhysicianName: '',
    sendStatus: null,
    isLatest,
    reports: mapReports(apiStudy.reports),
  };
}
